import React from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "@lib/types/Context";
import { SharedPaymentHistory } from "@app/shared";

const PaymentProviderPaymentHistories: React.FC = () => {
  const { providerId } = useParams();

  // Check if user has permission to view wallet pool
  // if (!permissions.canViewWalletPool) {
  //   return <NoPermission />;
  // }

  return (
    <SharedPaymentHistory
      context={AppContext.PAYMENT_PROVIDER}
      providerId={providerId}
    />
  );
};

export default PaymentProviderPaymentHistories;
